<template>
    <div class="card-week">
        <div :class="'card-week-header '+active" id="headingOne">
            <h5 class="mb-0">
                <button ref="headerWeek" :class="(active=='')?'btn btn-week collapsed':'btn btn-week'" @click="getAvaiableProducts()" :style="headerColor(this.addWeek)" data-toggle="collapse" :data-target="'#collapse-week-'+week[0]+week[1]" aria-expanded="true" aria-controls="collapseOne">
                    Semana {{week[1]}}
                    <span>
                        {{ subtitleHeader }}
<!--                        ({{week[1]}} - {{week[2]}})-->

                    </span>
                    <span class="float-right icon plus">
                        <img src="/img/iconos/icon_plus_white.svg" alt="icon_plus_white.svg">

                    </span>
                    <span class="float-right icon minus">
                        <img src="/img/iconos/icon_minus.svg" alt="icon_minus.svg">
                    </span>
                </button>
            </h5>
        </div>

        <div :id="'collapse-week-'+week[0]+week[1]" :class="'collapse '+active" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="card-week-body">
                <load-spiner v-if="loading"></load-spiner>
                <swiper v-else ref="week-Swiper" :options="swiperOption">
                    <swiper-slide v-for="articulo in orderArticulosOffer" :key="articulo.id">
                        <product-block :articulo="articulo" :add-week="addWeek" :eco="filters.eco"></product-block>
                    </swiper-slide>
                    <swiper-slide v-for="articulo in orderArticulos" :key="articulo.id">
                        <product-block :articulo="articulo" :add-week="addWeek" :eco="filters.eco"></product-block>
                    </swiper-slide>
                    <swiper-slide>
                        <contact-block :week="week[1]"></contact-block>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-disponible-prev" slot="button-prev">
                        <div class="swiper-button-disponible"></div>
                    </div>
                    <div class="swiper-button-disponible-next" slot="button-next">
                        <div class="swiper-button-disponible swiper-button-disponible-right"></div>
                    </div>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        props: ['addWeek','filters','week'],
        data() {
            return {
                articulos: "",
                articulos_offer: "",
                active: "show",
                loading: true,
                swiperOption: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    /*centeredSlides: true,*/
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-disponible-next',
                        prevEl: '.swiper-button-disponible-prev'
                    },
                    touchStartPreventDefault: false,
                }
            }
        },
        mounted() {
            this.$on('getAvaiableProducts', function(){
                this.getAvaiableProducts();
            });

            this.hideBlock();
        },
        watch: {
            filters: {
                handler: function() {
                    if(!this.$refs.headerWeek.className.match(/\bcollapsed\b/)) {
                        this.getAvaiableProducts();
                    }
                },
                deep: true
            }
        },
        computed: {
            orderArticulos: function () {
                var order='asc';
                if(this.filters.ordenar.length>0){
                    if(this.filters.ordenar[0].id==1){
                        order='asc';
                    }else if(this.filters.ordenar[0].id==2){
                        order='desc';
                    }
                }
                return _.orderBy(this.articulos, ['especie_verify.nombre','nombre_verify'],[order]);
            },
            orderArticulosOffer: function () {
                var order='asc';
                if(this.filters.ordenar.length>0){
                    if(this.filters.ordenar[0].id==1){
                        order='asc';
                    }else if(this.filters.ordenar[0].id==2){
                        order='desc';
                    }
                }
                return _.orderBy(this.articulos_offer, ['especie_verify.nombre','nombre_verify'],[order]);
            },
            subtitleHeader: function () {
                let week = this.week[1];
                let year = this.week[0];

                var miercoles = moment().locale('es').year(year).week(week).isoWeekday(3);

                return `entrega próximo miércoles ${miercoles.format("DD")} de ${miercoles.format("MMMM")}`;
            }
        },
        methods: {
            getAvaiableProducts: function () {
                this.loading=true;
                axios.post('/products/get-avaiable/', {
                    addWeek: this.addWeek,
                    filters: this.filters,
                }).then(response => {
                    this.articulos = response.data.articulos;
                    this.articulos_offer = response.data.articulos_offer;

                    this.loading = false;
                }).catch(e => {
                    console.log(e);
                });
            },
            hideBlock: function() {
                if(this.addWeek!=1) {
                    this.active = "";
                } else {
                    this.getAvaiableProducts();
                }
            },
            headerColor: function (key) {
                if(key == "1"){
                    return{
                        color: 'white !important',
                        backgroundColor: '#00b1a9'
                    }
                }else if(key == "2"){
                    return{
                        color: 'white !important',
                        backgroundColor: '#009ea1'
                    }
                }else if(key == "3"){
                    return{
                        color: 'white !important',
                        backgroundColor: '#028a83'
                    }
                }else{
                    return{
                        color: 'white !important',
                        backgroundColor: '#007273'
                    }
                }
            }
        }
    }
</script>

<style scoped>

    .swiper-button-disponible-prev, .swiper-button-disponible-next {
        position: absolute;
        height: 30px;
        width: 30px;
        top: 35%;
        z-index: 10;
        margin-top: -22px;
    }

    .swiper-button-disponible-prev {
        right: auto;
        left: 0;
    }

    .swiper-button-disponible-next {
        right: 0;
        left: auto;
    }

    .swiper-button-disabled {
        display: none;
    }

    .swiper-button-disponible.swiper-button-disponible-right {
        transform: rotate(270deg);
        top: -7px; /* Cuadrar */
    }
</style>

<style lang="scss" scoped>
$size: 40px;
$speed: 3s;
$peakopacity:0.9;
$rotate: 90deg;
$red: 0;
$green: 113;
$blue: 188;

.swiper-button-disponible {
    position: absolute; /* Cuadrar */
    top: 7px; /* Cuadrar */
    width:100%;
    height:100%;
    transform:rotate($rotate);
    &:before {
        content: '';
        position: absolute;
        width:100%;
        height:100%;
        border-left:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        border-bottom:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        transform:translate($size/3,$size*4/3)rotate(-45deg);
        animation: swiper-button-disponible $speed linear infinite;
    }
    &:after {
        content: '';
        position: absolute;
        width:100%;
        height:100%;
        border-left:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        border-bottom:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        transform:translate($size*2/3,0px)rotate(-45deg) ;
        animation: swiper-button-disponible $speed linear infinite $speed/-2;
    }
}

@keyframes swiper-button-disponible {
    0% {
        border-left:$size/3 solid rgba($red,$green,$blue,0);
        border-bottom:$size/3 solid rgba($red,$green,$blue,0);
        transform:translate($size/-6,$size*4/-6)rotate(-45deg) ;
    }
    10%, 90% {
        border-left:$size/3 solid rgba($red,$green,$blue,0);
        border-bottom:$size/3 solid rgba($red,$green,$blue,0);
    }
    50% {
        border-left:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        border-bottom:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        transform:translate($size/-6,0px)rotate(-45deg) ;
    }
    100% {
        border-left:$size/3 solid rgba($red,$green,$blue,0);
        border-bottom:$size/3 solid rgba($red,$green,$blue,0);
        transform:translate($size/-6,$size*4/6)rotate(-45deg) ;
    }
}
</style>
